<template>
    <div class="mb-3 relative">
        <div class="mb-2" >
            <h2 class="mb-0 text-[16px]" ref="sub-audience" >
                <template v-if="$widgetUI=='OLD-UI'">Contact Info</template>
            </h2>
        </div>

        <div>
            <div>
                <template v-for="item in subAudiences">
                    <v-radio v-model="subAudience"
                             :key="item.key"
                             :value="item.code"
                             class="block">
                        {{ item.title }}
                    </v-radio>
                </template>
            </div>

            <div class="text-[12px] text-gray-400"
                 v-if="audience === $widgetConfig.b2bBase">
                Your list will may include multiple contacts for the same company. Try narrowing down your
                results by Job Title or Job Level.
            </div>

            <template v-if="xPerSelection">
                <div class="border-t mt-2 pt-2">
                    <div class="flex items-center justify-between w-full mb-2"
                         ref="x-per-selection">
                        {{ xPerSelection.title }}
                        <help-tip v-if="xPerSelection.description" :content="xPerSelection.description"/>
                    </div>

                    <radio-list :with-check-icon="false"
                                :xPerSelection="true"
                                :item="xPerSelection"/>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { EventBus } from "@widget/plugins/event-bus";
import RadioList from "./selections/types/radio-list";
import xPerSelectionMixin from "../mixins/xPerSelection";

export default {
    name: "contact-info",
    components: {
        RadioList
    },
    computed: {
        audience () {
            return this.$store.getters["widgetData/selectedData"].audience;
        },
        subAudience: {
            set (value) {
                this.$store.commit("widgetData/setSubAudience", value);
            },
            get () {
                return this.$store.getters["widgetData/selectedData"].subAudience;
            }
        },
        audiences () {
            return this.$store.getters["widgetData/getAudienceData"];
        },
        subAudiences () {
            return this.$store.getters["widgetData/getAudienceChildren"];
        }
    },
    mixins: [
        xPerSelectionMixin
    ],
    watch: {
        audience () {
            this.checkXPerSelection();
        },
        subAudience () {
            this.checkXPerSelection();
        }
    },
    created () {
        this.checkXPerSelection();
    },
    mounted () {
        EventBus.$on("show-select-position", (select) => {
            if (select.code && select.code.includes("_one_per_address")) {
                EventBus.$emit("show-tippy-modify", this.$refs["x-per-selection"]);
            } else if (select === "sub-audience") {
                EventBus.$emit("show-tippy-modify", this.$refs["sub-audience"]);
            }
        });
    }
};
</script>
